import "./src/styles/global.css"
export const disableCorePrefetching = () => true;
